import { Components, Theme } from '@mui/material/styles';

import * as Colors from 'src/theme/colors';

const MuiSwitch: Components<Theme>['MuiSwitch'] = {
  styleOverrides: {
    root: {
      width: 30,
      height: 20,
      padding: 0,
      display: 'flex',
      position: 'relative',
      '& .MuiButtonBase-root': {
        '&:hover': {
          color: Colors.white,
        },
      },
    },
    switchBase: {
      padding: 0,
      color: Colors.white,
      zIndex: 5,
      marginTop: '3px',
      marginLeft: '3px',
      '&.Mui-checked': {
        transform: 'translateX(10px)',
        color: Colors.white,
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: Colors.green,
        },
      },
      '&.MuiSwitch-colorSecondary.Mui-disabled': {
        color: '#fff',
      },
    },
    thumb: {
      width: 14,
      height: 14,
      boxShadow: 'none',
    },
    track: {
      borderRadius: 10,
      opacity: 1,
      backgroundColor: Colors.NonHoverBorder,
    },
  },
};

export default MuiSwitch;
